var stats_mixin = {
  methods: {
    listFilterId(filters, new_filters) {
      if (new_filters.replaced_occupation_id_in) {
        filters.replaced_occupation_id_in = new_filters.replaced_occupation_id_in.map((value) => value.id);
      } else {
        filters.replaced_occupation_id_in = ''
      }
      if (new_filters.replaced_service_id_in) {
        filters.replaced_service_id_in = new_filters.replaced_service_id_in.map((value) => value.id);
      } else {
        filters.replaced_service_id_in = ''
      }
      if (new_filters.hub_id_in) {
        filters.hub_id_in = new_filters.hub_id_in.map((value) => value.id);
      } else {
        filters.hub_id_in = ''
      }
      if (new_filters.entity_id_in) {
        filters.entity_id_in = new_filters.entity_id_in
      } else {
        filters.entity_id_in = ''
      }
    }
  }
}
export default stats_mixin;



// WEBPACK FOOTER //
// ./src/mixin/stats.js